// extracted by mini-css-extract-plugin
module.exports = {"formPropousal":"styles_formPropousal__3YIKE"};